import styled from 'styled-components';

export const GridContainer = styled.div.attrs({
  className: 'ag-theme-material',
})`
  width: 100%;
  .ag-cell, .ag-header-cell {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
`;

export const CardView = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  margin: -4px;
`;
